import { Component }      from "@angular/core";
import { StatusListener } from "../../../status-listener";
import { AppService }     from "../../../services/app.service";

@Component({
	selector: "kkb-tur-help-panel",
	templateUrl: "./tur-help-panel.component.html",
	styleUrls: ["./tur-help-panel.component.scss", "../../../pages/tur/tur.scss", "../tur.components.scss"]
})
export class TurHelpPanelComponent extends StatusListener {

	visibility: Visibility = "";
	visibilityAgb = true;
	visibilitySanifair = false;
	visibilityContents = false;

	constructor(app: AppService) {
		super(app);
	}

	toggleHelpPopup(event: Event = null) {
		this.visibility = this.visibility === "popupVisible" ? "" : "popupVisible";
		if (event)
			this.cancelClick(event);
	}

	preventBubble(event: Event = null) {
		if (event) {
			event.stopPropagation();
		}
	}

	hideAllCards() {
		this.visibilityAgb = false;
		this.visibilitySanifair = false;
		this.visibilityContents = false;
	}

	toggleAgbCard(event: Event) {
		if (false === this.visibilityAgb) {
			this.hideAllCards();
			this.visibilityAgb = true;
		}
		this.cancelClick(event);
	}

	toggleSanifairCard(event: Event) {
		if (false === this.visibilitySanifair) {
			this.hideAllCards();
			this.visibilitySanifair = true;
		}
		this.cancelClick(event);
	}

	toggleContentsCard(event: Event) {
		if (false === this.visibilityContents) {
			this.hideAllCards();
			this.visibilityContents = true;
		}
		this.cancelClick(event);
	}

	cancelClick(event: Event) {
		event.stopPropagation();
	}

}

type Visibility = "" | "popupVisible" | "";
